(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flaunt-page-transition"] && !Shopify.designMode) return;
  try {
    (() => {
  const route = window.FlauntRoute;
  if (!route || window.Shopify?.designMode) return;
  const root = document.documentElement;
  const normalize = path => path.replace(/\/+$/, '') || '/';
  const home = normalize(route.home);
  const catalog = normalize(route.catalog);
  const from = normalize(location.pathname);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const resources = {};
  let warmed = false;
  let leaving = false;
  let navigationTimer;
  let safetyTimer;
  const isPair = (first, second) => (first === home && second === catalog) || (first === catalog && second === home);

  const destination = anchor => {
    if (!anchor || anchor.hasAttribute('download') || (anchor.target && anchor.target.toLowerCase() !== '_self')) return null;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || !isPair(from, normalize(url.pathname))) return null;
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview && !url.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', preview);
    return url;
  };

  const mediaURL = value => {
    if (typeof value !== 'string' || !value) return null;
    const url = new URL(value, location.href);
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  };

  const prefetch = async url => {
    if (warmed || normalize(url.pathname) !== catalog) return;
    warmed = true;
    try {
      const response = await fetch(url.href, { credentials: 'same-origin', priority: 'low' });
      if (!response.ok) return;
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = document.querySelector('[data-fcs-config]');
      if (!source) return;
      const config = JSON.parse(source.textContent);
      const poster = mediaURL(config.initial_poster);
      if (poster) {
        resources.poster = new Image();
        resources.poster.decoding = 'async';
        resources.poster.src = poster;
      }
      const connection = navigator.connection;
      if (connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType)) return;
      const first = config.chapters?.[0];
      const clip = mediaURL((matchMedia('(max-width: 749px)').matches && first?.mobile_forward) || first?.transition_forward);
      if (clip) {
        resources.video = window.document.createElement('video');
        resources.video.muted = true;
        resources.video.defaultMuted = true;
        resources.video.playsInline = true;
        resources.video.preload = 'auto';
        resources.video.src = clip;
        resources.video.load();
      }
    } catch (_) {}
  };

  const intent = event => {
    try {
      const url = destination(event.target instanceof Element ? event.target.closest('a[href]') : null);
      if (url) void prefetch(url);
    } catch (_) {}
  };
  ['pointerover', 'focusin', 'touchstart'].forEach(name => document.addEventListener(name, intent, { passive: true }));

  const reset = () => {
    clearTimeout(navigationTimer);
    clearTimeout(safetyTimer);
    leaving = false;
    root.classList.remove('flaunt-route-leaving');
  };

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    try {
      const url = destination(event.target instanceof Element ? event.target.closest('a[href]') : null);
      if (!url) return;
      if (leaving) { event.preventDefault(); return; }
      const at = Date.now();
      if (from === home) {
        const story = document.querySelector('flaunt-scroll-story');
        const index = Number(story?.dataset.target ?? story?.dataset.state);
        if (Number.isInteger(index) && index >= 0 && index < 6) sessionStorage.setItem(`${route.key}:home`, JSON.stringify({ index, at }));
      }
      sessionStorage.setItem(`${route.key}:pending`, JSON.stringify({ from, to: normalize(url.pathname), at }));
      void prefetch(url);
      event.preventDefault();
      leaving = true;
      root.classList.add('flaunt-route-leaving');
      navigationTimer = setTimeout(() => { location.assign(url.href); }, reduced.matches ? 120 : 180);
      safetyTimer = setTimeout(() => {
        reset();
        try { sessionStorage.removeItem(`${route.key}:pending`); } catch (_) {}
      }, 4000);
    } catch (_) { reset(); }
  });

  addEventListener('pageswap', event => {
    try {
      const url = event.activation?.entry?.url;
      if ((url && isPair(from, normalize(new URL(url).pathname))) || (!url && leaving)) event.viewTransition?.skipTransition();
    } catch (_) {}
  });

  const ready = () => {
    root.classList.remove('flaunt-route-entering');
    route.ready = true;
    document.dispatchEvent(new CustomEvent('flaunt:route-ready'));
  };
  addEventListener('pageshow', event => {
    if (event.persisted) {
      reset();
      ready();
    }
  });
  requestAnimationFrame(() => requestAnimationFrame(ready));
})();
  } catch(e) { console.error(e); }
})();

})();
